import { render } from "./orderdetails.vue?vue&type=template&id=56a9cf34&scoped=true"
import script from "./orderdetails.vue?vue&type=script&lang=js"
export * from "./orderdetails.vue?vue&type=script&lang=js"

import "./orderdetails.vue?vue&type=style&index=0&id=56a9cf34&lang=scss&scoped=true"

import exportComponent from "C:\\xampp\\htdocs\\project\\forex\\vue\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-56a9cf34"]])

export default __exports__